// NPM Imports
import React, { useContext, useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'
// Quote Context
import { useQuoteContext } from '../../../hooks/useQuoteContext'
// Component Imports
import SaveButton from '../misc/SaveButton'
// JS Imports
// Asset Imports
// Bootstrap Imports
import Button from 'react-bootstrap/Button'
import ButtonToolbar from 'react-bootstrap/ButtonToolbar'
import Navbar from 'react-bootstrap/Navbar'
import Container from 'react-bootstrap/Container'
import {
   PriceBookSelect,
   PrepaySelect,
   ResellerDiscount,
   DifferenceQuote,
   BilledCurrencyText,
   ToolbarActivationDate,
   ToolbarExpirationDate,
   TermSelect,
} from './'

export default function InternalToolbar({
   pricebookId,
   setPricebookIDCallback,
   productPerformanceEECount,
   setProductPerformanceEECount,
   productTestAccount,
   setProductTestAccount,
}) {
   const state = useQuoteContext()
   const { getString } = state
   const permissionsInternalToolbar =
      state.featurePermissions['InternalToolbar']
   const permissionsPricebookSelectExternalStyle =
      state.featurePermissions['PricebookSelectExternalStyle']
   const permissionsInternalToolbarShareButton =
      state.featurePermissions['InternalToolbarShareButton']
   const permissionsInternalToolbarRefreshButton =
      state.featurePermissions['InternalToolbarRefreshButton']
   const permissionsInternalToolbarExpirationDate =
      state.featurePermissions['InternalToolbarExpirationDate']

   const [searchParams, updateSearchParams] = useSearchParams()

   if (
      state.user_view != 'External' &&
      permissionsInternalToolbar.includes(state.user_role)
   )
      return (
         <Navbar sticky='top' variant='light' bg='transparent'>
            <Container fluid style={{ display: 'block' }}>
               <ButtonToolbar
                  role='toolbar'
                  className='justify-content-between gap-4'
               >
                  <div className='justify-content-left'>
                     {!permissionsPricebookSelectExternalStyle.includes(
                        state.user_role,
                     ) &&
                        permissionsInternalToolbarShareButton.includes(
                           state.user_role,
                        ) && (
                           <Button
                              className='mx-2 my-0 px-4'
                              size='sm'
                              onClick={() => {
                                 //gets current URL
                                 let url = new URL(window.location)
                                 //Creates new Params object which includes all existing params (if any)
                                 let newParams = new URLSearchParams([
                                    ...Array.from(searchParams.entries()),
                                 ])
                                 //Sets user_view and user_role for new Params, overwriting the current values if any
                                 newParams.set('user_view', 'External')
                                 newParams.set('user_role', 'Sales')
                                 let newUrl = new URL(
                                    `${url.origin}${url.pathname}?${newParams}`,
                                 )
                                 // Opens new url
                                 window.open(
                                    newUrl,
                                    '',
                                    'width=1000,height=800,toolbar=no,menubar=no,resizable=yes,scrollbars=no,titlebar=no,status=no',
                                 )

                                 return false
                              }}
                           >
                              {getString('global.Share')}
                           </Button>
                        )}
                     {!permissionsPricebookSelectExternalStyle.includes(
                        state.user_role,
                     ) &&
                        permissionsInternalToolbarRefreshButton.includes(
                           state.user_role,
                        ) && (
                           <Button
                              className='mx-2 my-0 px-4'
                              size='sm'
                              onClick={() => {
                                 window.location.reload()
                              }}
                           >
                              {getString('global.Refresh')}
                           </Button>
                        )}

                     <SaveButton
                        size='sm'
                        className='mx-2 my-0 px-4'
                        productPerformanceEECount={productPerformanceEECount}
                        setProductPerformanceEECount={
                           setProductPerformanceEECount
                        }
                        productTestAccount={productTestAccount}
                        setProductTestAccount={setProductTestAccount}
                     />
                  </div>

                  <ResellerDiscount />
                  <DifferenceQuote />

                  {state.user_role === 'Super Admin' ||
                  state.user_role === 'Admin' ? (
                     <BilledCurrencyText />
                  ) : null}

                  <PriceBookSelect
                     pricebookId={pricebookId}
                     setPricebookIDCallback={setPricebookIDCallback}
                     updateSearchParams={updateSearchParams}
                     size='sm'
                  />
                  <ToolbarActivationDate size='sm' />

                  <TermSelect />
                  <PrepaySelect />

                  {permissionsInternalToolbarExpirationDate.includes(
                     state.user_role,
                  ) && (
                     <div
                        className={
                           state.user_role === 'Super Admin' ||
                           state.user_role === 'Admin' ||
                           state.user_role === 'Billing' ||
                           state.user_role === 'Expansion Manager' ||
                           state.user_role === 'Expansion'
                              ? 'mx-2'
                              : ''
                        }
                     >
                        <ToolbarExpirationDate size='sm' />
                     </div>
                  )}
               </ButtonToolbar>
            </Container>
         </Navbar>
      )
   else if (permissionsInternalToolbar.includes(state.user_role))
      return (
         <PriceBookSelect
            pricebookId={pricebookId}
            setPricebookIDCallback={setPricebookIDCallback}
            updateSearchParams={updateSearchParams}
         />
      )

   // Return null when user_role is not in permissionsInternalToolbar
   return null
}
